function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var _excluded = ["image_base64"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../components/ConfigContext';
import ForwardToInboxIcon from '../../public/forward_to_inbox.svg';
import DefaultProductImage from '../../public/StudioConCON.svg';
import Cookies from 'js-cookie';
import { Box, Card, CardContent, Typography, Link as MuiLink, CircularProgress } from '@mui/material';
import { constants, ROUTES } from '../constants';
import { useApplicationsList } from '@/components/ApplicationContext';
import { PermissionGate } from '@/components/PermissionGate';
import { ADMIN_ACCESS_ACTIONS } from '@/utils/permissionGateConfig';
import authenticatedRoute from '@/views/AuthenticatedRoute';
import { useThemeDetails } from '../components/ThemeDetailsContext';
import PlatformAdministration from '../../public/PlatformAdministration.svg';
import { navigateToApp } from '@/utils/crossAppNavigation';
var handleTruncationTooltip = function handleTruncationTooltip(e, text) {
    var el = e.currentTarget;
    el.title = el.scrollHeight > el.clientHeight ? text : '';
};
var ProductCard = function ProductCard(_ref) {
    var _ref2, _product$details, _product$details2, _product$details3, _configState$settings, _product$details9, _product$details0;
    var product = _ref.product, onClick = _ref.onClick;
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    var isUnavailable = ((_ref2 = (product === null || product === void 0 || (_product$details = product.details) === null || _product$details === void 0 ? void 0 : _product$details.applicationState) || '') === null || _ref2 === void 0 ? void 0 : _ref2.toLowerCase()) !== 'active';
    var hasDescription = (product === null || product === void 0 || (_product$details2 = product.details) === null || _product$details2 === void 0 ? void 0 : _product$details2.applicationDescription) && (product === null || product === void 0 || (_product$details3 = product.details) === null || _product$details3 === void 0 ? void 0 : _product$details3.applicationDescription.trim().length) > 0;
    var buttonColor = (configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color) || '#26890D';
    var handleClick = function handleClick() {
        var _product$details$prod, _product$details4;
        if (isUnavailable)
            return;
        onClick(product === null || product === void 0 ? void 0 : product.id, (_product$details$prod = product === null || product === void 0 || (_product$details4 = product.details) === null || _product$details4 === void 0 ? void 0 : _product$details4.productName) !== null && _product$details$prod !== void 0 ? _product$details$prod : '');
    };
    var handleDescriptionTranslation = function handleDescriptionTranslation(product, key) {
        var _product$details8;
        var user = Cookies.get('user');
        if (user) {
            try {
                var _JSON$parse$details;
                var selected_language = ((_JSON$parse$details = JSON.parse(user).details) === null || _JSON$parse$details === void 0 ? void 0 : _JSON$parse$details.selected_language) || 'en';
                if (selected_language && selected_language !== 'en') {
                    if (key === 'desc') {
                        var _product$details5;
                        var description = "description_".concat(selected_language);
                        return (product === null || product === void 0 || (_product$details5 = product.details) === null || _product$details5 === void 0 ? void 0 : _product$details5[description]) || (product === null || product === void 0 ? void 0 : product.description);
                    }
                    else {
                        var _product$details6, _product$details7;
                        var _description = "applicationDescription_".concat(selected_language);
                        return (product === null || product === void 0 || (_product$details6 = product.details) === null || _product$details6 === void 0 ? void 0 : _product$details6[_description]) || (product === null || product === void 0 || (_product$details7 = product.details) === null || _product$details7 === void 0 ? void 0 : _product$details7.applicationDescription);
                    }
                }
            }
            catch (error) {
                // If JSON parsing fails, fall through to return default
                console.error('Error parsing user cookie:', error);
            }
        }
        return key === 'desc' ? product === null || product === void 0 ? void 0 : product.description : product === null || product === void 0 || (_product$details8 = product.details) === null || _product$details8 === void 0 ? void 0 : _product$details8.applicationDescription;
    };
    return /*#__PURE__*/ React.createElement(Card, {
        sx: {
            width: '100%',
            height: {
                xs: 'auto',
                sm: hasDescription ? '21.5rem' : '16rem'
            },
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isUnavailable ? '#F8F8F8' : '#FFFFFF',
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            boxShadow: 'none',
            cursor: isUnavailable ? 'not-allowed' : 'pointer',
            '&:hover': isUnavailable ? {} : {
                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.25)',
                '& .image-box': {
                    maxHeight: {
                        xs: '5.75rem',
                        sm: '7.5625rem'
                    },
                    minHeight: {
                        xs: '5.75rem',
                        sm: '7.5625rem'
                    }
                },
                '& .image-box::after': {
                    opacity: 0
                }
            }
        },
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(Box, {
        className: "image-box",
        sx: {
            maxHeight: isUnavailable ? '5rem' : {
                xs: '6.5rem',
                sm: '8.5rem'
            },
            minHeight: isUnavailable ? '5rem' : {
                xs: '6.5rem',
                sm: '8.5rem'
            },
            backgroundColor: '#F5F5F5',
            borderRadius: '8px 8px 0 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            transition: 'all 0.3s ease',
            '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: buttonColor === '#26890D' ? '#F5F5F5' : buttonColor,
                opacity: 0.6,
                transition: 'opacity 0.3s ease',
                pointerEvents: 'none',
                borderRadius: '8px 8px 0 0'
            }
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: (product === null || product === void 0 || (_product$details9 = product.details) === null || _product$details9 === void 0 ? void 0 : _product$details9.image_base64) || DefaultProductImage,
        alt: "".concat(product === null || product === void 0 ? void 0 : product.name, " logo"),
        style: {
            height: '100%',
            width: '100%',
            objectFit: 'cover'
        }
    })), /*#__PURE__*/ React.createElement(CardContent, {
        sx: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            p: '16px !important',
            gap: 1.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: isUnavailable ? '#595959' : '#121212',
        fontWeight: 600,
        sx: {
            mb: 0.5
        }
    }, product === null || product === void 0 ? void 0 : product.name), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "#545454ff",
        component: "div",
        sx: {
            minHeight: 40
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            fontWeight: 800,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
        },
        onMouseEnter: function onMouseEnter(e) {
            return handleTruncationTooltip(e, handleDescriptionTranslation(product, 'desc') || '');
        }
    }, handleDescriptionTranslation(product, 'desc')), /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical'
        },
        onMouseEnter: function onMouseEnter(e) {
            return handleTruncationTooltip(e, handleDescriptionTranslation(product, 'appDesc') || '');
        }
    }, handleDescriptionTranslation(product, 'appDesc'))), isUnavailable && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mt: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            px: 2,
            py: 1.5,
            borderRadius: 999,
            bgcolor: '#EBEBEB',
            color: '#45484bff',
            fontWeight: 600,
            fontSize: '0.9rem',
            lineHeight: 1
        }
    }, constants.unavailable), /*#__PURE__*/ React.createElement(MuiLink, {
        href: "mailto:".concat(product === null || product === void 0 || (_product$details0 = product.details) === null || _product$details0 === void 0 ? void 0 : _product$details0.contactEmail),
        underline: "none",
        sx: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            color: '#3C4043',
            fontWeight: 600,
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        onClick: function onClick(e) {
            return e.stopPropagation();
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: ForwardToInboxIcon,
        alt: "Forward to inbox",
        style: {
            width: 18,
            height: 18
        }
    }), /*#__PURE__*/ React.createElement("span", null, constants.email_your_admin)))));
};
var AdministrationCard = function AdministrationCard() {
    var _configState$settings2;
    var navigate = useNavigate();
    var _useContext2 = useContext(ConfigContext), configState = _useContext2.configState;
    var buttonColor = (configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.button_color) || '#26890D';
    return /*#__PURE__*/ React.createElement(Card, {
        sx: {
            width: '100%',
            height: {
                xs: 'auto',
                sm: '21.5rem'
            },
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            boxShadow: 'none',
            cursor: 'pointer',
            '&:hover': {
                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.25)',
                '& .image-box': {
                    maxHeight: {
                        xs: '5.75rem',
                        sm: '7.5625rem'
                    },
                    minHeight: {
                        xs: '5.75rem',
                        sm: '7.5625rem'
                    }
                },
                '& .image-box::after': {
                    opacity: 0
                }
            }
        },
        onClick: function onClick() {
            return navigate(ROUTES.SETTINGS);
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        className: "image-box",
        sx: {
            maxHeight: {
                xs: '6.5rem',
                sm: '8.5rem'
            },
            minHeight: {
                xs: '6.5rem',
                sm: '8.5rem'
            },
            backgroundColor: '#F5F5F5',
            borderRadius: '8px 8px 0 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            transition: 'all 0.3s ease',
            '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: buttonColor === '#26890D' ? '#F5F5F5' : buttonColor,
                opacity: 0.6,
                transition: 'opacity 0.3s ease',
                pointerEvents: 'none',
                borderRadius: '8px 8px 0 0'
            }
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: PlatformAdministration,
        alt: "Administration logo",
        style: {
            height: '100%',
            width: '100%',
            objectFit: 'cover'
        }
    })), /*#__PURE__*/ React.createElement(CardContent, {
        sx: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            p: '16px !important',
            gap: 1.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: '#121212',
        fontWeight: 600,
        sx: {
            mb: 0.5
        }
    }, "Administration"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "#545454ff",
        component: "div",
        sx: {
            minHeight: 40
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            fontWeight: 800,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
        },
        onMouseEnter: function onMouseEnter(e) {
            return handleTruncationTooltip(e, constants.administration_subtitle);
        }
    }, constants.administration_subtitle), /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical'
        },
        onMouseEnter: function onMouseEnter(e) {
            return handleTruncationTooltip(e, constants.administration_description);
        }
    }, constants.administration_description))));
};
var ProductSelection = function ProductSelection() {
    var _useContext3 = useContext(ConfigContext), configState = _useContext3.configState, setConfigState = _useContext3.setConfigState;
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), products = _useState2[0], setProducts = _useState2[1];
    var _useState3 = useState(true), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    var getApplications = useApplicationsList();
    useEffect(function () {
        var loadApplications = /*#__PURE__*/ function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var apps, currentApp, _t;
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.p = _context.n) {
                            case 0:
                                _context.p = 0;
                                setLoading(true);
                                _context.n = 1;
                                return getApplications();
                            case 1:
                                apps = _context.v;
                                setProducts(apps || []);
                                currentApp = apps.find(function (app) {
                                    var _app$details;
                                    return (app === null || app === void 0 || (_app$details = app.details) === null || _app$details === void 0 ? void 0 : _app$details.baseApp) === 'true';
                                });
                                if (currentApp) {
                                    setConfigState(_objectSpread(_objectSpread({}, configState), {}, {
                                        selectedProduct: String(currentApp.id)
                                    }));
                                    sessionStorage.setItem('current_application', JSON.stringify(currentApp));
                                    Cookies.set('Product Selected', String(currentApp.id), {
                                        secure: true,
                                        sameSite: 'Strict'
                                    });
                                }
                                _context.n = 3;
                                break;
                            case 2:
                                _context.p = 2;
                                _t = _context.v;
                                console.error('Error fetching applications:', _t);
                            case 3:
                                _context.p = 3;
                                setLoading(false);
                                return _context.f(3);
                            case 4:
                                return _context.a(2);
                        }
                }, _callee, null, [[0, 2, 3, 4]]);
            }));
            return function loadApplications() {
                return _ref3.apply(this, arguments);
            };
        }();
        loadApplications();
        Cookies.remove('Product Selected');
        sessionStorage.removeItem('current_application');
    }, []);
    var handleProductClick = function handleProductClick(productId, productSlug) {
        var _currentApp$details, _productSlug$toLowerC, _productSlug$toLowerC2;
        var currentApp = products.find(function (app) {
            return app.id === productId;
        });
        var productUrl = currentApp === null || currentApp === void 0 || (_currentApp$details = currentApp.details) === null || _currentApp$details === void 0 ? void 0 : _currentApp$details.productUrl;
        var isJupyter = productSlug === null || productSlug === void 0 || (_productSlug$toLowerC = productSlug.toLowerCase()) === null || _productSlug$toLowerC === void 0 ? void 0 : _productSlug$toLowerC.includes('jupyter');
        var isSuperset = productSlug === null || productSlug === void 0 || (_productSlug$toLowerC2 = productSlug.toLowerCase()) === null || _productSlug$toLowerC2 === void 0 ? void 0 : _productSlug$toLowerC2.includes('superset');
        if (isJupyter) {
            if (productUrl) {
                window.open(productUrl, '_blank', 'noopener,noreferrer');
            }
            else {
                console.error("No productUrl found for product \"".concat(productSlug, "\""));
            }
            return;
        }
        if (isSuperset) {
            if (productUrl) {
                window.open(productUrl, '_blank', 'noopener,noreferrer');
            }
            else {
                console.error("No productUrl found for product \"".concat(productSlug, "\""));
            }
            return;
        }
        setConfigState(_objectSpread(_objectSpread({}, configState), {}, {
            selectedProduct: String(productId)
        }));
        Cookies.set('Product Selected', String(productId), {
            secure: true,
            sameSite: 'Strict'
        });
        if (currentApp) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var _ref4 = currentApp.details || {}, image_base64 = _ref4.image_base64, detailsWithoutImage = _objectWithoutProperties(_ref4, _excluded);
            var appToStore = _objectSpread(_objectSpread({}, currentApp), {}, {
                details: detailsWithoutImage
            });
            sessionStorage.setItem('current_application', JSON.stringify(appToStore));
        }
        navigateToApp("/".concat(productSlug));
    };
    var sortedProducts = useMemo(function () {
        return _toConsumableArray(products).filter(function (app) {
            var _app$details2;
            return (app === null || app === void 0 || (_app$details2 = app.details) === null || _app$details2 === void 0 || (_app$details2 = _app$details2.purpose) === null || _app$details2 === void 0 ? void 0 : _app$details2.toLowerCase()) !== 'internal';
        }).sort(function (a, b) {
            var _a$details, _b$details;
            // First, sort by active status (active cards first)
            var isActiveA = ((a === null || a === void 0 || (_a$details = a.details) === null || _a$details === void 0 ? void 0 : _a$details.applicationState) || '').toLowerCase() === 'active';
            var isActiveB = ((b === null || b === void 0 || (_b$details = b.details) === null || _b$details === void 0 ? void 0 : _b$details.applicationState) || '').toLowerCase() === 'active';
            if (isActiveA && !isActiveB)
                return -1;
            if (!isActiveA && isActiveB)
                return 1;
            // Then sort alphabetically within each group
            var nameA = (a === null || a === void 0 ? void 0 : a.name) || '';
            var nameB = (b === null || b === void 0 ? void 0 : b.name) || '';
            return nameA.localeCompare(nameB);
        });
    }, [products]);
    if (loading) {
        var _configState$settings3;
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'calc(100vh - 60px)',
                overflow: 'hidden'
            }
        }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
            component: "img",
            src: stateImages.Loading,
            alt: "Loading",
            sx: {
                width: 128,
                height: 128
            }
        }) : /*#__PURE__*/ React.createElement(CircularProgress, {
            size: 60,
            sx: {
                color: configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.button_color
            }
        }));
    }
    return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'grid',
            gap: 2,
            px: 2,
            pb: 2,
            pt: 2,
            gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(auto-fill, minmax(22rem, 22rem))'
            },
            justifyContent: 'center'
        }
    }, sortedProducts === null || sortedProducts === void 0 ? void 0 : sortedProducts.map(function (p) {
        return /*#__PURE__*/ React.createElement(Box, {
            key: p.id
        }, /*#__PURE__*/ React.createElement(ProductCard, {
            product: p,
            onClick: handleProductClick
        }));
    }), /*#__PURE__*/ React.createElement(PermissionGate, {
        action: ADMIN_ACCESS_ACTIONS
    }, /*#__PURE__*/ React.createElement(AdministrationCard, null))));
};
export default authenticatedRoute(ProductSelection);
